import gql from 'graphql-tag'

export const TimelineEventFragment = gql`
  fragment TimelineEvent on ActionEventType {
    id
    type
    author {
      id
      fullName
    }
    assignee {
      id
      fullName
    }
    priorityBefore
    priorityAfter
    deadline
    status
    date
  }
`
